import { apiClient } from './client';

export interface DemoRequestSubmission {
    name: string;
    email: string;
    company: string;
    role?: string;
    teamSize?: string;
    monthlyRevenue?: string;
    channels?: string[];
    slot?: string;
    message?: string;
}

export interface DemoRequestSubmitResult {
    id: string;
    status: string;
}

export const demoRequestsApi = {
    submit: async (payload: DemoRequestSubmission): Promise<DemoRequestSubmitResult> => {
        const res = await apiClient.post('/demo-requests', payload);
        return res.data.data;
    },
};
